var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('p',[_vm._v("SHARE PAGE:")]),_vm._v("\n  "+_vm._s(_vm.file)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }